import { call, put, takeLatest } from 'redux-saga/effects';
import { TEST_CALL_ACTION_TYPES, testCallActions } from '../test-call';
import { checkPermission } from './checkPermission';

function* handleTestCallInPopup({ payload }) {
  /**
   * Request permission before start call
   * */
  yield call(checkPermission);
  yield put(testCallActions.open(payload));
}

export function* watchTestCallModalOpen() {
  yield takeLatest(TEST_CALL_ACTION_TYPES.INIT, handleTestCallInPopup);
}



// WEBPACK FOOTER //
// ./src/redux/healthboard/sagas/test-call-in-popup-saga.js